import { Suspense } from 'react';
import RouteErrorBoundary from './RouteErrorBoundary';
import PageLoader from '../PageLoader';

/**
 * Safe Route Wrapper
 * Combines Suspense for lazy loading and ErrorBoundary for error handling
 */
const SafeRoute = ({ children, routeName, fallbackMessage }) => {
  return (
    <RouteErrorBoundary routeName={routeName} fallbackMessage={fallbackMessage}>
      <Suspense fallback={<PageLoader />}>
        {children}
      </Suspense>
    </RouteErrorBoundary>
  );
};

export default SafeRoute;
